import i18next from 'i18next';
import {
  AppsV1IdentityResponse,
  UserInfo,
  //GenesisUserInfoResponse,
} from '../../types';
import { getProfileConfigs } from './profile-configs';

export class UserDataExtractor {
  /**
   * Extracts user information from identity data
   */
  static extract(
    identityData: AppsV1IdentityResponse,
    isBilling = true,
  ): UserInfo {
    const profileConfigs = getProfileConfigs();
    const profileConfig = isBilling
      ? profileConfigs['billing']
      : profileConfigs['revenue'];
    return {
      firstName: identityData?.firstName || '',
      lastName: identityData?.lastName || '',
      userName: identityData?.username || '',
      role: identityData?.jobTitle || '',
      email: identityData?.email || '',
      profileConfig,
    };
  }

  /**
   * Extracts user display name with fallback logic
   */
  static getDisplayName(identityData: AppsV1IdentityResponse): string {
    const { firstName, lastName } = identityData || {};

    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    }

    if (firstName) {
      return firstName;
    }

    if (lastName) {
      return lastName;
    }

    return identityData?.email?.split('@')[0] || 'User';
  }

  /**
   * Extracts user initials for avatar display
   */
  static getInitials(identityData: AppsV1IdentityResponse): string {
    const { firstName, lastName, email } = identityData || {};

    if (firstName && lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
    }

    if (firstName) {
      return firstName.charAt(0).toUpperCase();
    }

    if (email) {
      const emailName = email.split('@')[0];
      return emailName.charAt(0).toUpperCase();
    }

    return 'U';
  }

  /**
   * Extracts user permissions and role information
   */
  // static extractPermissions(
  //   identityData: AppsV1IdentityResponse,
  //   permissions: GenesisUserInfoResponse
  // ) {
  //   return {
  //     userId: identityData?.userId,
  //     email: identityData?.email,
  //     roles: identityData?.dashboardRole || [],
  //     permissions: permissions?.permissions || [],
  //     isAdmin: this.isUserAdmin(permissions),
  //     isSuperUser: this.isSuperUser(permissions)
  //   };
  // }

  /**
   * Checks if user has admin privileges
   */
  // private static isUserAdmin(permissions: GenesisUserInfoResponse): boolean {
  //   const adminRoles = ['admin', 'administrator', 'super_admin'];
  //   return permissions?.roles?.some(role =>
  //     adminRoles.includes(role.toLowerCase())
  //   ) || false;
  // }

  /**
   * Checks if user is a super user
   */
  // private static isSuperUser(permissions: GenesisUserInfoResponse): boolean {
  //   return permissions?.roles?.some(role =>
  //     role.toLowerCase().includes('super')
  //   ) || false;
  // }

  /**
   * Extracts user preferences if available
   */
  // static extractPreferences(identityData: AppsV1IdentityResponse) {
  //   return {
  //     timezone: identityData?.timezone || 'UTC',
  //     locale: identityData?.locale || 'en-US',
  //     dateFormat: identityData?.dateFormat || 'MM/DD/YYYY',
  //     timeFormat: identityData?.timeFormat || '12h',
  //     theme: identityData?.theme || 'light',
  //   };
  // }

  /**
   * Creates a complete user profile object
   */
  // static createUserProfile(
  //   identityData: AppsV1IdentityResponse,
  //   permissions?: GenesisUserInfoResponse
  // ) {
  //   const basicInfo = this.extract(identityData);
  //   const userPermissions = permissions ?
  //     this.extractPermissions(identityData, permissions) : null;
  //   const preferences = this.extractPreferences(identityData);

  //   return {
  //     ...basicInfo,
  //     displayName: this.getDisplayName(identityData),
  //     initials: this.getInitials(identityData),
  //     permissions: userPermissions,
  //     preferences,
  //     avatarUrl: identityData?.avatarUrl,
  //     lastLogin: identityData?.lastLogin,
  //     isActive: identityData?.isActive !== false,
  //   };
  // }

  /**
   * Validates that required user data is present
   */
  static validateUserData(identityData: AppsV1IdentityResponse): boolean {
    if (!identityData) {
      console.warn('No identity data provided');
      return false;
    }

    if (!identityData.email) {
      console.warn('User email is required but missing');
      return false;
    }

    return true;
  }

  /**
   * Creates a fallback user object when data is incomplete
   */
  static createFallbackUser(): UserInfo {
    return {
      firstName: i18next.t('GlobalNav.FallbackUser.FirstName'),
      lastName: i18next.t('GlobalNav.FallbackUser.LastName'),
      userName: 'guest@example.com',
      role: i18next.t('GlobalNav.FallbackUser.Role'),
      email: 'guest@example.com',
    };
  }

  /**
   * Main extraction method with error handling and fallback
   */
  static extractWithFallback(
    identityData: AppsV1IdentityResponse,
    //permissions?: GenesisUserInfoResponse,
  ): UserInfo {
    try {
      if (!this.validateUserData(identityData)) {
        console.warn('Invalid user data, using fallback');
        return this.createFallbackUser();
      }

      return this.extract(identityData);
    } catch (error) {
      console.error('Error extracting user data:', error);
      return this.createFallbackUser();
    }
  }
}
